/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ScanInputs */



/**
* | output |
* | --- |
* | "Scan" |
*
* @param {Nav_ScanInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_scan = /** @type {((inputs?: Nav_ScanInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ScanInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Scannen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scanner")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("扫描")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("掃描")
	if (locale === "ko") return /** @type {LocalizedString} */ ("스캔")
	return /** @type {LocalizedString} */ ("Scan")
});